// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconButton {
    align-self: center
}
.valueselected{
    background:var(--appbuilder-primary-color);
    color:var(--appbuilder-hover-color);
}
.withoutcaption{
    width:33px;
}
.toggle-button {
    border: 1px solid var(--appbuilder-primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/togglebutton/togglebutton.theme.control.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;IACI,0CAA0C;IAC1C,mCAAmC;AACvC;AACA;IACI,UAAU;AACd;AACA;IACI,iDAAiD;AACrD","sourcesContent":[".iconButton {\n    align-self: center\n}\n.valueselected{\n    background:var(--appbuilder-primary-color);\n    color:var(--appbuilder-hover-color);\n}\n.withoutcaption{\n    width:33px;\n}\n.toggle-button {\n    border: 1px solid var(--appbuilder-primary-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
